import { render, staticRenderFns } from "./VehicleCard.vue?vue&type=template&id=41ba5db0&scoped=true&"
import script from "./VehicleCard.vue?vue&type=script&lang=js&"
export * from "./VehicleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba5db0",
  null
  
)

export default component.exports